// components/GameStartingPlaceholder.jsx: M3-11 placeholder shown
// after GAME_STARTING. M4 replaces this with the real game handoff.
//
// The placeholder MUST clearly communicate it's a placeholder (AC #5)
// so playtesters don't think the lobby is broken. Visual cue: large
// dashed border + "Milestone 4 wires the real game" copy.

import '../styles/room-settings.css';

/**
 * @param {{
 *   occupantCount: number,
 *   botFill: boolean,
 *   onReturn?: () => void,
 * }} props
 */
export function GameStartingPlaceholder({ occupantCount, botFill, onReturn }) {
  const TOTAL_SEATS = 4;
  const botsFilling = botFill ? Math.max(0, TOTAL_SEATS - occupantCount) : 0;
  // Vite gates dev-only UI off import.meta.env.DEV, the Return button
  // doesn't ship in the production preview.
  const showReturn = typeof import.meta !== 'undefined' && import.meta.env?.DEV && !!onReturn;

  return (
    <section
      class="game-starting-placeholder"
      data-testid="game-starting-placeholder"
      role="status"
      aria-live="polite"
    >
      <h2 class="game-starting-title">Game starting</h2>
      <p class="game-starting-line" data-testid="game-starting-line">
        {botsFilling > 0
          ? `${botsFilling} bot(s) filling ${botsFilling} seat(s).`
          : `${occupantCount} player(s) ready.`}
      </p>
      <p class="game-starting-placeholder-tag" data-testid="game-starting-placeholder-tag">
        This is an M3 placeholder. Multiplayer game wiring lands in Milestone 4.
      </p>
      {showReturn && (
        <button
          type="button"
          class="game-starting-return"
          data-testid="game-starting-return"
          onClick={onReturn}
        >
          Return to room (dev only)
        </button>
      )}
    </section>
  );
}
